import { useState, useCallback } from "react"
import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { cn } from "../lib/utils"

const COUNTRY_CODES = ["+1", "+44", "+82", "+81", "+49", "+33", "+86", "+91"]

export function PhoneInputRenderer({ element }: RendererProps) {
  const { dispatchEvent } = useRenderContext()
  const [code, setCode] = useState("+1")
  const [phone, setPhone] = useState("")

  const dispatch = useCallback(
    (countryCode: string, phoneNumber: string) => {
      dispatchEvent(element.id, "change", { countryCode, phoneNumber })
    },
    [element.id, dispatchEvent],
  )

  return (
    <div
      className={cn("flex flex-row gap-2 items-center", element.className)}
      data-testid={`phone-input-${element.id}`}
    >
      <select
        className="flex h-9 rounded-md border border-input bg-transparent px-2 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        value={code}
        onChange={(e) => {
          setCode(e.target.value)
          dispatch(e.target.value, phone)
        }}
        aria-label="Country code"
      >
        {COUNTRY_CODES.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
      <input
        type="tel"
        className="flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
        placeholder={element.placeholder ?? "(555) 123-4567"}
        value={phone}
        onChange={(e) => {
          setPhone(e.target.value)
          dispatch(code, e.target.value)
        }}
        aria-label={element.ariaLabel ?? "Phone number"}
      />
    </div>
  )
}
